import { Directive, OnChanges } from '@angular/core';
import { FlexAlignDirective as FlexLayoutFlexAlignDirective } from '@angular/flex-layout';

const inputs = [
  'flLayoutFlexAlign',
  'flLayoutFlexAlign.mobile',
  'flLayoutFlexAlign.tablet',
  'flLayoutFlexAlign.desktop-small',
  'flLayoutFlexAlign.desktop-large',
  'flLayoutFlexAlign.desktop-xlarge',
  'flLayoutFlexAlign.desktop-xxlarge',
];

@Directive({
  selector: `
    [flLayoutFlexAlign],
    [flLayoutFlexAlign.mobile],
    [flLayoutFlexAlign.tablet],
    [flLayoutFlexAlign.desktop-small],
    [flLayoutFlexAlign.desktop-large],
    [flLayoutFlexAlign.desktop-xlarge],
    [flLayoutFlexAlign.desktop-xxlarge],
  `,
  inputs,
})
export class FlexAlignDirective extends FlexLayoutFlexAlignDirective
  implements OnChanges {
  protected inputs = inputs;
}
